<template>
    <div style="" class="uk-grid" id="schedule-app-main-div" >
        <!-- reference: https://www.pbssocal.org/schedule/?search=antiques+roadshow -->

      <!--
      Done: {{text_search_done}}
      -->
      <div class="uk-width-1-1 schedule-header" style="margin-top:0px;background: #f8eeca; padding: 0;">

        <TopNavigationBar v-bind:search_type="type" />

        <div v-if="text_search_input !== null && !loading && multi_channel_schedule_data != undefined && Object.keys(multi_channel_schedule_data).length > 0 && multi_channel_schedule_data['1'].length == 0 && multi_channel_schedule_data['2'].length == 0 && multi_channel_schedule_data['3'].length == 0 && multi_channel_schedule_data['4'].length == 0"  class="uk-visible@xs uk-hidden@s uk-grid uk-grid-large gridcenter1200" style="background: white;padding:10px;">
          <div style="min-height: 63px;padding-top:12px;padding-left: 10px;padding-bottom: 10px;">
            <!-- CELTIC DREAMS: DANIEL HOPE'S HIDDEN IRISH HISTORY
            CHANGE YOUR BRAIN, HEAL YOUR MIND WITH DANIEL AMEN, MD
            OVERCOMING ANXIETY, DEPRESSION, TRAUMA, AND GRIEF WITH DANIEL AMEN MD AND TANA A-->
            <!-- div class="all-air-dates-progtitle">{{text_search_input}}</div -->
            <div style="font-size: 20px; font-family: Avenir-medium; line-height: 1;">
              This program has already aired.
            </div>
          </div>
        </div>

        <!-- NEW MENU-->
        <div :class="`${(exact_match === '1' || text_search_done)? 'uk-visible@s':''}`">
          <!-- MENU WITH LOGO AND DATE/CALENDAR -->
          <div v-if="exact_match !== '1' || text_search_done" :style="`${((exact_match !== '1' && text_search_input === null) || !text_search_done) ? 'background-color: rgb(248, 238, 202); padding: 25px 0 20px 0;`':'min-height: 108px;padding: 12px 10px 10px;background: white'}`" i>
            <div class="uk-grid uk-grid-large gridcenter1200">
              <!--LOGO MAIN SCHEDULE-->
              <div :class="`${(exact_match !== '1' || !text_search_done) ? 'uk-width-3-5@m':''} uk-visible@s`" style="padding: 0px 5px;">

                <div style="float: left; padding: 0 10px 0 0;">
                  <img v-if="channel === 1" src="/images/schedule/channel-121-pbs12.svg" style="height: 60px;">
                  <img v-if="channel === 2" src="/images/schedule/channel-122-fnx.svg" style="height: 60px;">
                  <img v-if="channel === 3" src="/images/schedule/channel-123-dw.svg" style="height: 60px;">
                  <img v-if="channel === 4" src="/images/schedule/channel-124-nhk.svg" style="height: 60px;">
                </div>
                <div v-if="!text_search_done && channel === -1" style="float: left; padding: 12px 0 0px 10px; ">
                  <div style="font-size: 45px; font-family: Avenir-Book; line-height: 1;color:black;">SCHEDULE</div>
                </div>
                <div style="float: left; padding: 10px 0 0px 10px; " v-if="exact_match !== '1' ">
                  <div v-if="channel !== -1" style="font-size: 14px; font-family: Avenir-medium; line-height: 1;color:black;">CHANNEL 12.{{channel}}</div>
                  <div v-else-if="text_search_done" style="font-size: 14px; font-family: Avenir-medium; line-height: 1;">SEARCH RESULTS FOR:</div>
                  <div v-else style="color:black;font-size: 14px; font-family: Avenir-medium; line-height: 1;color:black;">ALL CHANNELS</div>
                  <div v-if="!text_search_done && channel !== -1" style="font-size: 24px; font-family: Avenir-Book; line-height: 1.2;color:black;">SCHEDULE</div>
                  <div v-else-if="!text_search_done && channel === -1" style="font-size: 24px; font-family: Avenir-Book; line-height: 1.2;color:black;">GRID</div>

                  <div v-else class="all-air-dates-progtitle" style="line-height: 1;padding-top:12px;min-height: 60px;margin-bottom:0;">
                    '{{decodeURI(text_search_input)}}'
                  </div>
                </div>

                <div v-else-if="text_search_input !== null && !loading" style="min-height: 63px;padding-top:12px;">
<!-- CELTIC DREAMS: DANIEL HOPE'S HIDDEN IRISH HISTORY
CHANGE YOUR BRAIN, HEAL YOUR MIND WITH DANIEL AMEN, MD
OVERCOMING ANXIETY, DEPRESSION, TRAUMA, AND GRIEF WITH DANIEL AMEN MD AND TANA A-->


                  <div class="all-air-dates-progtitle" v-if="text_search_input.length > 70" style="font-size: 24px;">{{text_search_input}}</div>
                  <div class="all-air-dates-progtitle" v-else-if="text_search_input.length > 60" style="font-size: 29px;">{{text_search_input}}</div>
                  <div class="all-air-dates-progtitle" v-else-if="text_search_input.length > 50" style="font-size: 35px;">{{text_search_input}}</div>
                  <div class="all-air-dates-progtitle" v-else-if="text_search_input.length > 40" style="font-size: 40px;">{{text_search_input}}</div>
                  <div class="all-air-dates-progtitle" v-else-if="text_search_input.length > 30" style="font-size: 48px;">{{text_search_input}}</div>
                  <div class="all-air-dates-progtitle" v-else-if="text_search_input.length > 32">{{text_search_input}}</div>
                  <div class="all-air-dates-progtitle" v-else>{{text_search_input}}</div>
                  <div div style="font-size: 20px; font-family: Avenir-medium; line-height: 1;"
                       v-if="multi_channel_schedule_data['1'].length == 0 && multi_channel_schedule_data['2'].length == 0 && multi_channel_schedule_data['3'].length == 0 && multi_channel_schedule_data['4'].length == 0">
                    This program has already aired.
                  </div>
                  <div v-else style="font-size: 14px; font-family: Avenir-medium; line-height: 1;">
                    <span style="font-size: 16px; color: grey; font-family: Avenir-Medium;">is on </span>
                    <a href="#channel-12-1-separator" uk-scroll="offset: 200" style="color: rgb(0, 174, 180);font-size: 16px; font-family: Avenir-Medium;" v-if="multi_channel_schedule_data['1'].length > 0">CHANNEL 12.1</a>
                    <span style="font-size: 16px; color: grey; font-family: Avenir-Medium;" v-if="multi_channel_schedule_data['2'].length > 0 || multi_channel_schedule_data['3'].length > 0|| multi_channel_schedule_data['4'].length > 0"> and </span>
                    <a href="#channel-12-2-separator" uk-scroll="offset: 200" style="color: rgb(0, 174, 180);font-size: 16px; font-family: Avenir-Medium;" v-if="multi_channel_schedule_data['2'].length > 0">CHANNEL 12.2</a>
                    <span style="font-size: 16px; color: grey; font-family: Avenir-Medium;" v-if="multi_channel_schedule_data['3'].length > 0 || multi_channel_schedule_data['4'].length > 0"> and </span>
                    <a href="#channel-12-3-separator" uk-scroll="offset: 200" style="color: rgb(0, 174, 180);font-size: 16px; font-family: Avenir-Medium;" v-if="multi_channel_schedule_data['3'].length > 0">CHANNEL 12.3</a>
                    <span style="font-size: 16px; color: grey; font-family: Avenir-Medium;" v-if="multi_channel_schedule_data['4'].length > 0"> and </span>
                    <a href="#channel-12-4-separator" uk-scroll="offset: 200" style="color: rgb(0, 174, 180);font-size: 16px; font-family: Avenir-Medium;" v-if="multi_channel_schedule_data['4'].length > 0">CHANNEL 12.4</a>
                  </div>
                </div>
                <div v-if="exact_match !== '1' && !text_search_input" style="clear: both;"></div>
              </div>

              <div class="uk-width-2-5@m" style="padding: 0px 0 0 0px;" v-if="exact_match !== '1' && !text_search_done">
                <div class="uk-visible@xs uk-hidden@m" style="height: 20px;"></div>
                <div style="min-height:20px; color: black; font-family: Avenir-heavy; font-size: 22px; text-align: center; margin-bottom: 5px;text-transform: uppercase">
                  <span><img @click="fetch_previous" src="/images/schedule/pbs-arrow-left.svg" style="width: 13px; margin-top: -4px;cursor: pointer"></span>
                  <div style="display: contents;margin-bottom:15px;cursor: pointer;" @click="open_calendar">
                    {{formatted_date}}
                  </div>
                  <!--WEDNESDAY, JAN 27-->
                  <span><img @click="fetch_next" src="/images/schedule/pbs-arrow-right.svg" style="width: 13px; margin-top: -4px;cursor:pointer;"></span>
                  <span id="date-picker-anchor" slot="afterDateInput"></span>
                  <datepicker v-model="calendar_date" @selected="calendar_selected"
                              :typeable="false" :inline="false"
                              :calendar-button-icon="'calendar-button'"
                              v-bind:calendarButton="true"
                              class="calendar-button hasDatepicker" >
                  </datepicker>
                </div>
                <div style="border-bottom: 1px solid #00AEB4;margin-top:10px;"></div>
                <ul v-if="channel !== -1" class="uk-child-width-expand uk-tab-bottom" uk-tab style="margin-top: 0px;">
                  <li style="border: 0;" :class="`${(prime_week)?'':'uk-active'} schedule-all-day-li`" @click="change_to_type" refresh-action='{"mode": "schedule", "prime_week": "false"}'><a id="schedule-all-day-button" @click="change_to_type" refresh-action='{"mode": "schedule", "prime_week": "false"}'><div style="max-height: 25px;" :class="`${(prime_week)?'font-black':''}`">ALL DAY</div></a></li>
                  <li style="border: 0;" :class="`${(prime_week)?'uk-active':''} schedule-primetime-li`" @click="activate_prime_week(true)"><a @click="activate_prime_week(true)" ><div style="max-height: 25px;" :class="`${(!prime_week)?'font-black':''}`">PRIMETIME WEEK</div></a></li>
                </ul>
                <ul v-else class="uk-child-width-expand uk-tab-bottom" uk-tab style="margin-top: 0px;">
                  <li style="border: 0;" :class="`${(prime_week)?'':'uk-active'}`" @click="change_to_type" refresh-action='{"mode": "schedule","prime_week": "false"}'><a @click="change_to_type" id="_schedule-all-day-button" refresh-action='{"mode": "schedule","prime_week": "false"}'><div style="max-height: 25px;" :class="`${(prime_week)?'font-black':''}`">ALL DAY</div></a></li>
                  <li style="border: 0;" :class="`${(prime_week)?'uk-active':''}`" @click="change_to_type" refresh-action='{"mode": "evening","prime_week": "true"}'><a @click="change_to_type" refresh-action='{"mode": "evening","prime_week": "true"}'><div style="max-height: 25px;" :class="`${(!prime_week)?'font-black':''}`">PRIMETIME WEEK</div></a></li>
                </ul>
              </div>


            </div>

          </div>


          <!--CHANNELS-->
          <div style="background-color: #F6DF98; padding-top: 10px; padding-bottom: 10px;" v-if="(exact_match !== '1' && text_search_input === null) || !text_search_done">

            <div class="uk-grid uk-grid-large gridcenter1200">

              <div class="uk-width-1-1@m uk-visible@xs uk-hidden@s" style="padding: 0px 5px 10px 5px;">
                <select id="channel_selector_dropdown" class="select-pbs-schedule" name="ch" v-model="channel_" @change="change_channel">
                  <option value="1">CHANNEL 12.1 &mdash; PBS12</option>
                  <option value="2">CHANNEL 12.2 &mdash; FNX</option>
                  <option value="3">CHANNEL 12.3 &mdash; Deutsche Welle</option>
                  <option value="4">CHANNEL 12.4 &mdash; NHK World</option>
                </select>
              </div>

              <div class="uk-width-1-1@m uk-visible@s" style="padding: 0px;">
                <div style="border-bottom: 1px solid #00AEB4;"></div>
                <ul class="uk-child-width-expand uk-tab-bottom" uk-tab style="margin-top: 0;">
                  <li style="border: 0;" :class="`uk-hidden@xs uk-visible@s ${(channel === -1 && !text_search_done) ? 'uk-active':'uk-inactive'}`"><a @click="change_channel(-1)"><div style="max-height: 25px;color: black;">ALL CHANNELS</div></a></li>
                  <li :class="`${(channel === 1) ? 'uk-active':''}`" style="border: 0;" ><a @click="change_channel('1')"><img src="/images/schedule/channel-121-pbs12.svg" style="max-height: 25px;"></a></li>
                  <li :class="`${(channel === 2) ? 'uk-active':''}`" style="border: 0;"><a @click="change_channel('2')"><img src="/images/schedule/channel-122-fnx.svg" style="max-height: 25px;"></a></li>
                  <li :class="`${(channel === 3) ? 'uk-active':''}`" style="border: 0;"><a @click="change_channel('3')"><img src="/images/schedule/channel-123-dw.svg" style="max-height: 25px;"></a></li>
                  <li :class="`${(channel === 4) ? 'uk-active':''}`" style="border: 0;"><a @click="change_channel('4')"><img src="/images/schedule/channel-124-nhk.svg" style="max-height: 25px;"></a></li>
                </ul>
              </div>
            </div>

          </div>




        </div>
      </div>

      <!--
      <div class="uk-width-1-1 all-air-dates-bar" v-if="exact_match === '1'  && !loading && false" >

            <div style="margin-left:auto; margin-right: auto;width: 88%;text-align: center;display: block;margin-bottom: 20px;margin-top:30px;min-height: 50px;" class="uk-search uk-search-default">
                <a  class="uk-button uk-button-small uk-button-primary" @click="reset_exact_match" style="float: left;margin-right: 0;padding-bottom: 1px;" >main schedule page</a>
                <a  class="uk-button uk-button-small uk-button-primary" style="float: right;margin-right: 0" @click="show_schedule_filter = true">SEARCH SCHEDULE
                  <img src="https://www.pbs12.org/images/schedule/search-icon.svg" style="width: 25px;height: 25px;">
                </a>
            </div>

            <div v-if="show_schedule_filter" style="width: 100%;text-align: center;display: inline-block" class="uk-search uk-search-default">
                <a class="uk-search-icon-flip search-button-icon uk-icon uk-search-icon" style="font-size: 16px;color: #01aeb4;font-weight: bold;text-decoration: none;width: 140px;padding-right: 150px;" uk-search-icon><span class="uk-visible@m"> SEARCH </span><span style="letter-spacing: 5px;color:transparent">.</span></a>
                <input v-on:keyup.enter="filter_schedule_results" @change="filter_schedule_results" v-model="schedule_results_filter" type="text" class="schedule-channel-selector-input schedule-channel-selector avenir-medium size-20"
                        style="width: 88%;max-width: unset;margin-left: 0;" placeholder="enter a program or episode title">
            </div>

            <div v-if="multi_channel_schedule_data['1'] != undefined" style="margin-left:auto; margin-right: auto;width: 88%;display: block;margin-bottom: 20px;margin-top:30px;min-height: 90px;" class="uk-search uk-search-default">
                <h1 style="text-transform: uppercase;text-align: left;margin-bottom: 5px;">{{text_search_input}}</h1>
                <span style="color: #777777;font-family: 'Avenir-Light', 'Nunito', sans-serif, sans-serif;font-size: 20px;">is on</span>
                <a href="#channel-12-1-separator" uk-scroll class="light-green" v-if="multi_channel_schedule_data['1'].length > 0">
                    CHANNEL 12.1
                    <span style="color: #777777;font-family: 'Avenir-Light', 'Nunito', sans-serif, sans-serif;font-size: 20px;" v-if="multi_channel_schedule_data['2'].length > 0 || multi_channel_schedule_data['3'].length > 0|| multi_channel_schedule_data['4'].length > 0"> and </span>
                </a>
                <a href="#channel-12-2-separator" uk-scroll  class="light-green" v-if="multi_channel_schedule_data['2'].length > 0">
                    CHANNEL 12.2
                    <span style="color: #777777;font-family: 'Avenir-Light', 'Nunito', sans-serif, sans-serif;font-size: 20px;" v-if="multi_channel_schedule_data['3'].length > 0 || multi_channel_schedule_data['4'].length > 0"> and </span>
                </a>
                <a href="#channel-12-3-separator" uk-scroll  class="light-green" v-if="multi_channel_schedule_data['3'].length > 0">
                    CHANNEL 12.3
                    <span style="color: #777777;font-family: 'Avenir-Light', 'Nunito', sans-serif, sans-serif;font-size: 20px;" v-if="multi_channel_schedule_data['4'].length > 0"> and </span>
                </a>
                <a href="#channel-12-4-separator" uk-scroll  class="light-green" v-if="multi_channel_schedule_data['4'].length > 0">
                    CHANNEL 12.4
                </a>
            </div>
        </div>
         Done: {{text_search_done}}
        -->

        <!-- mode: {{mode}} {{(channel == -1 && prime_week)}} -->
        <MultiChannelSchedule v-if="!loading && !prime_week && mode !== 'evening' && (channel == -1 && (text_search_input == null || !text_search_done))" v-bind:mode="mode" v-bind:schedule_data="multi_channel_schedule_data" v-bind:current_day="current_day" v-bind:_id="'00'"/>
        <div v-if="!loading && mode === 'evening' && (channel == -1 && (text_search_input == null || !text_search_done)) && Object.keys(multi_channel_schedule_data).length > 0" style="width: 100%;padding:0;">
          <div v-for="(week_day, n) in Object.keys(week_schedule_data)" v-bind:key="n" style="width: 100%">
            <div style="width: 100%; background: rgb(76, 100, 100);">
              <h1 class="search-results-channel-separator" >{{week_day}}</h1>
            </div>
            <MultiChannelSchedule v-bind:mode="mode" v-bind:schedule_data="week_schedule_data[week_day]" v-bind:current_day="current_day" v-bind:_id="n"/>
          </div>
        </div>
        <SingleChannelSchedule v-else-if="!loading && !prime_week && (text_search_input == null || !text_search_done)" v-bind:schedule_data="schedule_data"  />
        <SearchResultsSchedule v-else-if="!loading && !prime_week && text_search_input" v-bind:schedule_data="schedule_data" v-bind:multi_channel_schedule_data="multi_channel_schedule_data" v-bind:channel="channel" />

        <div v-if="!loading && prime_week && channel !== -1 && Object.keys(week_schedule_data).length > 0" style="width: 100%;padding:0;">
          <div v-for="(week_day, n) in Object.keys(week_schedule_data)" v-bind:key="n" style="width: 100%">
            <div style="width: 100%; background: rgb(76, 100, 100);">
              <h1 class="search-results-channel-separator" >{{week_day}}</h1>
            </div>
            <SingleChannelSchedule v-if="n < 8" v-bind:schedule_data="week_schedule_data[week_day]"  />
          </div>
        </div>

        <div v-if="loading">
            Loading...
        </div>

        <div v-if="!text_search_done" class="uk-width-1-1 light-green" style="background: #f6df99;height: 37px;text-align: center;font-size: 15px;font-weight: bold;padding-top: 5px;">
            <span @click="fetch_next"><div class="view-next-bar" style=""> GO TO NEXT DAY</div></span>
        </div>
        <div v-else class="uk-width-1-1 light-green" style="background: #f6df99;height: 37px;text-align: center;font-size: 15px;font-weight: bold;padding-top: 5px;">
          <span @click="reset_search" style="cursor: pointer">RETURN TO MAIN SCHEDULE PAGE</span>
        </div>
        <div class="uk-sticky-placeholder" style="height: 124px; margin: 0px;" hidden=""></div>

    </div>
</template>

<script>

/**
 * Reference / Support material:
 *
 * https://www.pbssocal.org/schedule/
 *
 */

import axios from 'axios'
import SingleChannelSchedule from "./SingleChannelSchedule"
import MultiChannelSchedule from "./MultiChannelSchedule"
import SearchResultsSchedule from "./SearchResultsSchedule"
import Datepicker from 'vuejs-datepicker'
import $ from 'jquery'
import _ from 'lodash'
import uk from 'uikit'

import {mapGetters,mapActions} from 'vuex'
import TopNavigationBar from "@/components/TopNavigationBar";

export default {
    name: "PBS12Schedule",
    components: {TopNavigationBar, MultiChannelSchedule, SingleChannelSchedule, Datepicker,SearchResultsSchedule},
    props:['type','_channel','_current_day','exact_match','genre_list','_episode_id'],
    data(){
        return {
            /*channel: 1,*/
            base_url: 'https://www.pbs12.org/',
            //end_point: 'https://www.pbs12.org/schedule_rest.php?/',
            mode: 'schedule', // schedule/prime_time
            schedule_data: [],
            show_schedule_filter: false,
            multi_channel_schedule_data: [],
            week_schedule_data: [],
            current_day: null,
            iso_date: '',
            formatted_date: '',
            months:["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            week_days:["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            next_day:null,
            previous_day: null,
            calendar_open: false,
            calendar_date: null,
            //text_search_done: false,
            loading: false,
            unfiltered_schedule_data:[],
            schedule_results_filter: '',
            prime_week: false,
            channel_: 1
        }
    },
    computed:{
        ...mapGetters(['server_info','text_search_input','channel','text_search_done']),
        end_point(){
            if(window.location.href.match(/localhost/)) return 'https://www.pbs12.org/schedule_rest.php?/'
            return `https://${window.location.href.split('/')[2]}/schedule_rest.php?/`
        },
        week_schedule_url(){
          //return `${this.end_point}daily_schedule/week.${this.channel}/${this.use_date_or_search_input()}`
          return `${this.end_point}daily_schedule/week.${this.channel}/${this.use_date_or_search_input()}`
        },
        endpoint_url(){
          let match_type = ''
          if(this.exact_match === '1') match_type = '/1'
          if(this.mode === 'schedule') return `${this.end_point}daily_schedule/${this.channel}/${this.use_date_or_search_input()}${match_type}`
          if(this.mode === 'early_morning') return `${this.end_point}early_morning_schedule/${this.channel}/${this.use_date_or_search_input()}${match_type}`
          if(this.mode === 'morning') return `${this.end_point}morning_schedule/${this.channel}/${this.use_date_or_search_input()}${match_type}`
          if(this.mode === 'afternoon') return `${this.end_point}afternoon_schedule/${this.channel}/${this.use_date_or_search_input()}${match_type}`
          if(this.mode === 'evening') return `${this.end_point}evening_schedule/${this.channel}/${this.use_date_or_search_input()}${match_type}`
          return ``
        }
    },

    mounted() {

        if(this.type === 'evening_primetime'){
          this.type = 'evening'
          this.prime_week = true
        }
        if(this.type != undefined && this.type.length > 0 && this.type === 'early_morning') this.mode = 'early_morning'
        if(this.type != undefined && this.type.length > 0 && this.type === 'morning') this.mode = 'morning'
        if(this.type != undefined && this.type.length > 0 && this.type === 'afternoon') this.mode = 'afternoon'
        if(this.type != undefined && this.type.length > 0 && this.type === 'evening') this.mode = 'evening'
        if(this._channel != undefined && parseInt(this._channel) > -2 && parseInt(this._channel) < 5) this.changeCurrentChannel(this._channel)

        if(this._channel == -1 && this.mode == 'evening'){
          this.activate_prime_week(true)
        }else if(this._channel == -1){
          this.activate_prime_week(false)
        }
        if(this._channel > 0)  this.channel_ = this._channel

        console.log('this._current_day on mounted()', this._current_day)
        console.log('getFullYear:', new Date(this._current_day+"T10:00:00.000-00:00").getFullYear())
        let tmp_dt = new Date(this.server_info.date+"T10:00:00.000-00:00")
        // tmp_dt.toLocaleString('en-US', { timeZone: 'America/Denver' })
        if(this._current_day != undefined && new Date(this._current_day+"T10:00:00.000-00:00").getFullYear() > 2019){
            //console.log('using this date: ', this._current_day+"T10:00:00.000-00:00")
            tmp_dt = new Date(this._current_day+"T10:00:00.000-00:00")
            // tmp_dt.toLocaleString('en-US', { timeZone: 'America/Denver' })
        }else{
            this.searchInputData(
                 (this._current_day !=  undefined) ? decodeURI(this._current_day):undefined
            )
        }
        // tmp_dt.toLocaleString('en-US', { timeZone: 'America/Denver' })
        console.log('running setup_date()', tmp_dt)

        this.setup_date(tmp_dt)
        //this.fetch_schedule_data()
    },
    created() {
        $('.dropdown-menu').each((n, e) => { $(e).find('a').each( (n, ae) => { if(ae.href.match(/programs-a-z/)) { console.log(ae.href); ae.href = '/schedule/daily-schedule/#/programs_az/-1' }} ) })

        this._current_day = this.normalize_date(this._current_day)

        this.$watch("$route",() => {
            // this.$route.query is watched now as expected
            // console.log('current type:', this.type)
            // console.log('current type:', this.$route.params)

            this.mode = 'schedule'

            if(this.type === 'evening_primetime'){
              this.type = 'evening'
              this.prime_week = true
            }
            if(this.type != undefined && this.type.length > 0 && this.type === 'early_morning') this.mode = 'early_morning'
            if(this.type != undefined && this.type.length > 0 && this.type === 'morning') this.mode = 'morning'
            if(this.type != undefined && this.type.length > 0 && this.type === 'afternoon') this.mode = 'afternoon'
            if(this.type != undefined && this.type.length > 0 && this.type === 'evening') this.mode = 'evening'

            if(this._channel != undefined && parseInt(this._channel) > -2 && parseInt(this._channel) < 5) this.changeCurrentChannel(this._channel)

            this._current_day = this.normalize_date(this._current_day)

            if(this._current_day != undefined && new Date(this._current_day+'T10:00:00.000-00:00')){
                let tmp_dt = new Date(this._current_day+'T10:00:00.000-00:00')
                // tmp_dt.toLocaleString('en-US', { timeZone: 'America/Denver' })
                this.setup_date(tmp_dt)
                this.searchInputData(null)
            }else if(this._current_day != undefined){
              this.searchInputData(this._current_day)
            }

            if(this.text_search_input === undefined || this.text_search_input === null || this.text_search_input === '') {
              if(this.text_search_done || this.exact_match) this.activate_prime_week(false)
              this.fetch_schedule_data()
              // $('#date-picker-anchor').parent().parent().find('input[type=text]').remove()
              $('.dropdown-menu').each((n, e) => {
                $(e).find('a').each((n, ae) => {
                  if (ae.href.match(/programs-a-z/)) {
                    console.log(ae.href);
                    ae.href = '/schedule/daily-schedule/#/programs_az/-1'
                  }
                })
              })
            }
        }, { immediate: true })

        window.addEventListener('resize', () => {
           this.reset_players_height()
        })

        setTimeout(() => {
            if($('.uk-accordion-title').width() != undefined) {
                let _class = '.uk-accordion-title'
                let multiplier = .17
                let height = $(_class).width() * .50
                if ($(_class).width() > 900) height = $(_class).width() * multiplier
                //console.log('program details width: ' + _class, height)
                $('.pbs_media_manager_iframe').height(height)
                $('.pbs_media_manager_iframe').css('margin-bottom', '20px')
            }
        }, 1000)

    },
    methods:{
        ...mapActions(['searchInputData','changeCurrentChannel']),
        filter_schedule_results(){
            let ch1 = _.filter(this.unfiltered_schedule_data[1], data => {
                return data.episode_title.toLowerCase().match(this.schedule_results_filter.toLowerCase())
                    || data.series_title.toLowerCase().match(this.schedule_results_filter.toLowerCase())
            })
            let ch2 = _.filter(this.unfiltered_schedule_data[2], data => {
                return data.episode_title.toLowerCase().match(this.schedule_results_filter.toLowerCase())
                    || data.series_title.toLowerCase().match(this.schedule_results_filter.toLowerCase())
            })
            let ch3 = _.filter(this.unfiltered_schedule_data[3], data => {
                return data.episode_title.toLowerCase().match(this.schedule_results_filter.toLowerCase())
                    || data.series_title.toLowerCase().match(this.schedule_results_filter.toLowerCase())
            })
            let ch4 = _.filter(this.unfiltered_schedule_data[4], data => {
                return data.episode_title.toLowerCase().match(this.schedule_results_filter.toLowerCase())
                    || data.series_title.toLowerCase().match(this.schedule_results_filter.toLowerCase())
            })
            this.multi_channel_schedule_data = {
                1: ch1,
                2: ch2,
                3: ch3,
                4: ch4
            }
        },
        reset_exact_match(){
            this.schedule_results_filter = ''
            this.show_schedule_filter = false
            this.reset_search()

            // setTimeout(() => {
            // $('#date-picker-anchor').parent().parent().find('input[type=text]').remove()
            // }, 50)
            //this.$router.push({ name: 'schedule', params: { '_channel': 1, _current_day: 'undefined' }})
        },
        reset_players_height(){
            let _class = '.uk-accordion-title'
            if($('.uk-accordion-title').width() == undefined) _class = '.uk-modal-dialog'
            //console.log('program details width: ', $(_class).width())

            if($(_class).width() * .57 > 0) {
                setTimeout(() => {
                    let height = $(_class).width() *.50
                    if($(_class).width() > 900) height = $(_class).width()*.15
                    //console.log('program details width: ', height)
                    $('.pbs_media_manager_iframe').height(height)
                    $('.pbs_media_manager_iframe').css('margin-bottom', '20px')
                }, 100)
            }
        },
        use_date_or_search_input(){
            let iso_date_or_query = this.iso_date//text_search_input
            if(this.text_search_input != null ||
                (this._current_day != undefined && !this._current_day.match(/[0-9][0-9][0-9][0-9]-[0-9]+-[0-9]+/) && this._current_day.length > 0)){
                iso_date_or_query = this.text_search_input
                if(iso_date_or_query == null || iso_date_or_query === ''){
                    iso_date_or_query = this._current_day
                }else{
                    this.setup_date(new Date())
                }
                //this.text_search_done = true
                this.searchInputData(iso_date_or_query)
            }else{
                this.searchInputData(null)
                //this.text_search_done = false
            }
            //this.searchInputData((iso_date_or_query == undefined) ? iso_date_or_query:decodeURI(iso_date_or_query))

            //this.searchInputData(decodeURI(iso_date_or_query))
            return  encodeURIComponent(decodeURI(iso_date_or_query))
        },
        open_calendar(){
            $('.calendar-button').click()
        },
        normalize_date(yyyymmdd){
          if(yyyymmdd === undefined || yyyymmdd === null) return yyyymmdd
          console.log('Normalized date in:', yyyymmdd)
          if(yyyymmdd.match(/[0-9][0-9][0-9][0-9]-/)){
            let day_parts = yyyymmdd.split(/-/)
            if(day_parts.length == 3){
              if(day_parts[1].length == 1) day_parts[1] = '0'+day_parts[1]
              if(day_parts[2].length == 1) day_parts[2] = '0'+day_parts[2]
              yyyymmdd = `${day_parts[0]}-${day_parts[1]}-${day_parts[2]}`
            }
          }
          console.log('Normalized date out:', yyyymmdd)
          return yyyymmdd
        },
        activate_prime_week(active){
          this.prime_week = active
          let current_day = new Date(this.iso_date+'T05:00:00.000-00:00')
          // console.log('CUuuuuuuuur day: ', current_day)
          this.iso_date = this.normalize_date(`${current_day.getFullYear()}-${current_day.getMonth()+1}-${current_day.getUTCDate()}`)
          //this.formatted_date = `${this.week_days[current_day.getDay()]}, ${this.months[current_day.getMonth()]} ${current_day.getUTCDate()}`
          if(active){
            $('.modal-full-00').remove()
            $('.modal-full-0').remove()
            $('.modal-full-1').remove()
            $('.modal-full-2').remove()
            $('.modal-full-3').remove()
            //current_day.setDate(current_day.getUTCDate() + 1);
            this.formatted_date = `${this.months[current_day.getMonth()]} ${current_day.getUTCDate()}`
            current_day.setDate(current_day.getDate() + 6);
            this.formatted_date += ` - ${this.months[current_day.getMonth()]} ${current_day.getUTCDate()}`
            uk.scroll('#bottom_app_div', {offset: 0}).scrollTo('#app')
          }else{
            this.formatted_date = `${this.week_days[current_day.getDay()]}, ${this.months[current_day.getMonth()]} ${current_day.getUTCDate()}`
          }
        },
        setup_date(date){
            // console.log('cuuuuuuuuuuuurrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr', date)
            let current_day = date
            // current_day.toLocaleString('en-US', { timeZone: 'America/Denver' })

            this.current_day = current_day
            this.iso_date = this.normalize_date(`${current_day.getFullYear()}-${current_day.getMonth()+1}-${current_day.getUTCDate()}`)
            this.formatted_date = `${this.week_days[current_day.getDay()]}, ${this.months[current_day.getMonth()]} ${current_day.getUTCDate()}`

            current_day.setDate(current_day.getUTCDate() + 1);
            this.next_day = this.normalize_date(`${current_day.getFullYear()}-${current_day.getMonth()+1}-${current_day.getUTCDate()}`)
            console.log('next day: ', this.next_day)
            current_day.setDate(current_day.getUTCDate() - 2);
            this.previous_day = this.normalize_date(`${current_day.getFullYear()}-${current_day.getMonth()+1}-${current_day.getUTCDate()}`)
            console.log('previous day: ', this.previous_day)

            if(this.prime_week) this.activate_prime_week(true)
            // $('#date-picker-anchor').parent().parent().find('input[type=text]').remove()
        },
        change_to_type(evt){
            // console.log('evt: ',evt.target.className)
            // console.log('evt: ', $(evt.target).parent().attr('refresh-action'))
            if($(evt.target).parent().attr('refresh-action')) {
              let evt_data = JSON.parse($(evt.target).parent().attr('refresh-action'))
              this.mode = evt_data.mode
              this.activate_prime_week(evt.prime_week||this.mode === 'evening')
              if (evt.target.className === 'view-earlier-bar') this.mode = 'schedule'
              this.$router.push({
                name: 'schedule',
                params: {'type': this.mode, '_channel': this.channel, _current_day: this.use_date_or_search_input()}
              })
              console.log('current type:', this.type)
            }
            //this.fetch_schedule_data()
        },
        change_channel(channel=undefined){
          //uk.scroll('#bottom_app_div', {offset: 70}).scrollTo('#app',{duration:0})
          $('body,html').animate({ scrollTop: 80, }, 0)
          this.channel = parseInt(this.channel)
          setTimeout( () =>{
            console.log(channel instanceof Event)
            if(!(channel instanceof Event)){
              this.changeCurrentChannel(channel)
              console.log('on change channel 0: ', channel)
              this.channel_ = channel
            }else{
              channel = parseInt(this.channel_)
              this.changeCurrentChannel(channel)
              console.log('on change channel 1: ', channel)
            }
            channel = parseInt(channel)
            if(this.text_search_input != null){
              this.searchInputData(null)
              this.reset_search()
              console.log('on change channel: ', this.text_search_input)
            }else{
              if(channel == -1){
                $('.modal-full-00').remove()
                $('.modal-full-0').remove()
                $('.modal-full-1').remove()
                $('.modal-full-2').remove()
                $('.modal-full-3').remove()
              }
              if (channel == -1 && this.prime_week) this.type = 'evening'
              if(channel !== -1){
                this.type = "schedule"
                setTimeout( () => {
                  console.log('clicking on #schedule-all-day-button')
                  $('#schedule-all-day-li').addClass('uk-active')
                  $('#schedule-primetime-li').removeClass('uk-active')
                }, 2500)
              }
              console.log('Change channel', {
                name: 'schedule',
                params: {'type': this.type, '_channel': channel, _current_day: this.use_date_or_search_input()}
              })
              this.$router.push({
                name: 'schedule',
                params: {'type': this.type, '_channel': channel, _current_day: this.use_date_or_search_input()}
              })
            }
          }, 500)
        },
        calendar_selected(evt){
            // console.log('EVENT', evt)
            this.searchInputData(null)

            let current_day = evt
            this.current_day = current_day
            this.iso_date = `${this.current_day.getFullYear()}-${this.current_day.getMonth()+1}-${this.current_day.getUTCDate()}`
            this.formatted_date = `${this.week_days[current_day.getDay()]}, ${this.months[current_day.getMonth()]} ${current_day.getUTCDate()}`

            current_day.setDate(current_day.getUTCDate() + 1);
            this.next_day = this.normalize_date(`${current_day.getFullYear()}-${current_day.getMonth()+1}-${current_day.getUTCDate()}`)
            current_day.setDate(current_day.getUTCDate() - 2);
            this.previous_day = this.normalize_date(`${current_day.getFullYear()}-${current_day.getMonth()+1}-${current_day.getUTCDate()}`)

            //console.log('calendar date:', this.calendar_date)
            //this.current_day = this.toIsoDate(this.calendar_date)
            // console.log('set date to this date: ', this.current_day)
            // console.log('set date to this date: ', this.iso_date)
            this.$router.push({ name: 'schedule', params: { 'type': this.type, '_channel': this.channel, _current_day: this.iso_date }})
            //this.fetch_schedule_data()
        },
        reset_search(){
            this.searchInputData(null)
            this.setup_date(new Date(this.server_info.date+"T10:00:00.000-00:00"))
            this.$router.push({ name: 'schedule', params: { 'type': 1, '_channel': 1, _current_day: this.server_info.date}})
        },
        toIsoDate(date){
            return `${date.getFullYear()}-${date.getMonth()+1}-${date.getUTCDate()}`
        },
        toggle_calendar(){
            this.calendar_open = !this.calendar_open
            // console.log('calendar status: ', this.calendar_open)
        },
        reset_dates(iso_date){

            let current_day = new Date(iso_date+'T05:00:00.000-00:00')
            // current_day.toLocaleString('en-US', { timeZone: 'America/Denver' })

            // console.log('THHHHHHHHHHHHHHHHHHIiiiiiiiiiiiiiiisss is where it get fFFFFFFFFFFFFFFFFFFFFFFFfuuuuuuuuucked', iso_date)
            // console.log('THHHHHHHHHHHHHHHHHHIiiiiiiiiiiiiiiisss is where it get fFFFFFFFFFFFFFFFFFFFFFFFfuuuuuuuuucked', current_day)

            this.current_day = current_day
            this.iso_date = this.normalize_date(`${current_day.getFullYear()}-${current_day.getMonth()+1}-${current_day.getUTCDate()}`)
            this.formatted_date = `${this.week_days[current_day.getDay()]}, ${this.months[current_day.getMonth()]} ${current_day.getUTCDate()}`

            current_day.setDate(current_day.getUTCDate() + 1);
            this.next_day = this.normalize_date(`${current_day.getFullYear()}-${current_day.getMonth()+1}-${current_day.getUTCDate()}`)
            //console.log('NEXT DAYYYYYY', this.next_day)
            current_day.setDate(current_day.getUTCDate() - 2);
            this.previous_day = this.normalize_date(`${current_day.getFullYear()}-${current_day.getMonth()+1}-${current_day.getUTCDate()}`)
        },
        fetch_next(){
            // this.searchInputData(null)
            this.reset_dates(this.next_day)
            console.log('Running router.push: ', { name: 'schedule', params: { 'type': this.type, '_channel': this.channel, _current_day: this.iso_date }})
            this.$router.push({ name: 'schedule', params: { 'type': this.type, '_channel': this.channel, _current_day: this.iso_date }})
            //this.fetch_schedule_data()
        },
        fetch_previous(){
            // this.searchInputData(null)
            this.reset_dates(this.previous_day)
            this.$router.push({ name: 'schedule', params: { 'type': this.type, '_channel': this.channel, _current_day: this.iso_date }})
            //this.fetch_schedule_data()
        },
        fetch_schedule_data(channel=1, date_start=null, date_end=null){
            let vm = this
            // if(isNaN(date_start) || date_start == null) this.reset_search()
            //if(this.text_search_input != null && !(new String(document.location).match(this.text_search_input))) this.reset_search()
            console.log(`loading fetch_schedule_data - ${channel}, ${date_start}, ${date_end}`)
            console.log(`url: ${this.endpoint_url}`)

          // $('#date-picker-anchor').parent().parent().find('input[type=text]').remove()

            this.multi_channel_schedule_data = []
            this.schedule_data = []
            this.loading = true

            // Regular schedule
            axios.get(this.endpoint_url, {
                data: {},
                headers: {'Content-Type': 'application/json'}
            }).then( response => {
                this.loading = false
                if(this.channel > 0){
                    vm.schedule_data = response.data
                }else{
                    vm.multi_channel_schedule_data = response.data
                    vm.unfiltered_schedule_data = response.data
                }
                setTimeout(
                    () => {
                        // Where to scroll logic - if today - go to now playing position
                        if($("#schedule-now-playing-multi").html() != undefined) {
                          uk.scroll('#bottom_app_div', {offset: 400}).scrollTo('#schedule-now-playing-multi')
                        }else if($("#schedule-now-playing").html() != undefined && !this._episode_id) {

                          //     $('html, body').animate({scrollTop: $("#schedule-now-playing").offset().top - 200}, 1000)
                          if(window.innerWidth > 640) {
                            uk.scroll('#bottom_app_div', {offset: 240}).scrollTo('#schedule-now-playing')
                          }else{
                            uk.scroll('#bottom_app_div', {offset: 270}).scrollTo('#schedule-now-playing-mobile')
                          }
                          //$('#schedule-now-playing').click()
                        }else {
                          uk.scroll('#bottom_app_div', {offset: 0}).scrollTo('#app')
                        }
                        if(this.exact_match && !$('#schedule-search').hasClass('uk-hidden')){
                          $('#schedule-search').addClass('uk-hidden')
                        }
                    }, 300
                )
                setTimeout(
                    () => {
                        vm.reset_players_height()
                        $('.jw_js').each( (k, el) => {
                            let s = document.createElement("script")
                            s.type = "text/javascript"
                            s.src = $(el).attr('js_url')
                            console.log('loading player: ', $(el).attr('js_url'))
                            console.log('loading player: ', $(el).attr('air_time'))
                            $(el).append(s)
                        })
                    }, 100
                )
            }).catch(reason => {
                    console.log('failed to get schedule data', reason)
            })

          // Week schedule
            axios.get(this.week_schedule_url, {
              data: {},
              headers: {'Content-Type': 'application/json'}
            }).then(response => {
              //this.loading = false
              vm.week_schedule_data = response.data
            }).catch(reason => {
              console.log('failed to get schedule data', reason)
            })
        }
    }
}
</script>

<style scoped>

    .schedule-channel-selector{
        background-color: white;
        border: 2px solid black;
        height: 44px;
        padding-top: 9px;
    }

    .schedule-channel-selector-select{
      border: 2px solid black;
      height: 44px;
      padding-top: 5px;
      padding-left: 6px;
      background: url(https://www.pbs12.org/images/schedule/drop-down-arrow.svg) right / 20px no-repeat #fff;
      appearance: none;
      padding-right: 30px;

    }
    .vdp-datepicker {
      margin-top: -12px;
    }

    .datepicker__calendar.cell.day-header {
        font-size: 50%;
    }
    a:hover{
        text-decoration: none;
    }
    a:active{
        text-decoration: none;
    }
    .view-select-box{
        width: 100%;
    }
    .channel-select-box{
        width: 100%;
    }
    .search-box{
        padding-left: 40px;
    }
    @media screen and (min-width:992px) {
        .view-select-box{
            padding-left: 0;
            max-width: 235px;
        }
        .channel-select-box{
            max-width: 230px;
        }
        .search-box{
            padding-left: 0px;
        }
    }

    .uk-search-default .uk-search-icon {
        font-size: 16px;
        width: 40px;
        color: rgb(1, 174, 180);
        font-weight: bold;
        text-decoration: none;
    }

    @media screen and (min-width:992px) {

        .uk-search-default .uk-search-icon {
            width: 35px;
            margin-right: 5px;
        }
    }
    @media screen and (min-width:992px) {

        .uk-search-default .uk-search-icon {
            width: 90px;
            margin-right: 5px;
        }
    }

    @media (min-width: 768px) {
        .vdp-datepicker {
            margin-top: -23px;
        }
    }
    @media (min-width: 1200px) {
        .vdp-datepicker {
            margin-top: -12px;
        }
    }
    @media screen and (min-width:992px) {
        .vdp-datepicker {
            margin-top: -23px;
        }
    }

    @media screen and (min-width:1180px) {
      .vdp-datepicker {
        margin-top: -12px;
      }
    }
    .font-black{
      color: black;
    }
</style>